import { render, staticRenderFns } from "./VToolbarItems.vue?vue&type=template&id=374d7fc5&scoped=true&"
import script from "./VToolbarItems.vue?vue&type=script&lang=js&"
export * from "./VToolbarItems.vue?vue&type=script&lang=js&"
import style0 from "./VToolbarItems.vue?vue&type=style&index=0&id=374d7fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d7fc5",
  null
  
)

export default component.exports